type FilterCasesByStatusProps = {
  cases: any[];
  selectedStatus: string;
};

export const filterCasesByStatus = ({cases, selectedStatus}: FilterCasesByStatusProps) => {
  return cases?.filter((item) => (selectedStatus ? item.status === selectedStatus : true));
};
